import React from "react";
import { Figure } from "../../shared/Figure";
import Image from "next/image";
import contactUser from "./contactUser";
import { HiOutlineMail } from "react-icons/hi";
import { useRouter } from "next/router";

export default function index(props) {
  const router = useRouter();

  return (
    <div className="bg-[url('/bernard/contactus_bg.png')] bg-cover bg-no-repeat min-h-screen p-8">
      <div className="font-unilever-shilling-medium text-center text-2xl">
        Our Team
      </div>
      <div className="bg-[rgba(96,10,23,0.1)] rounded-md p-8 m-5">
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10">
          {contactUser.map(({ email, img, name }, idx) => (
            <Figure key={idx} className="mx-auto relative">
              <Image src={img} alt="" placeholder="blur" />
              <div className="absolute -bottom-2 w-[90%] left-[50%] translate-x-[-50%] bg-[#D9D9D9] rounded-md px-[0.65rem]">
                <div className="font-unilever-shilling-medium mt-[3px]">
                  {name}
                </div>
                <p className="font-unilever-shilling-normal text-[10px] lowercase">
                  {email}
                </p>
                <HiOutlineMail
                  onClick={() => {
                    router.push(`mailto:${email}`);
                  }}
                  className="w-4 h-4 absolute right-2 -top-1 cursor-pointer"
                />
              </div>
            </Figure>
          ))}
        </div>
      </div>
    </div>
  );
}

